import React, { useMemo } from 'react';
import { DocumentHead } from 'lib/components';

import { PreLoader } from './PreLoader';

const Wrapper = () => {
  return useMemo(() => <PreLoader />, []);
};

export const Customers = () => (
  <>
    <DocumentHead title='Manage Customers' />
    <Wrapper />
  </>
);
